import React from 'react'
import './Footer.css'

const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
)

const ShieldIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
)

/* Simple inline UPI logo wordmark */
const UpiLogo = () => (
  <svg width="36" height="18" viewBox="0 0 60 24" aria-label="UPI" role="img">
    <text
      x="0" y="19"
      fontFamily="'IBM Plex Sans', sans-serif"
      fontSize="20"
      fontWeight="700"
      fill="#7B61FF"
      letterSpacing="-1"
    >
      UPI
    </text>
  </svg>
)

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="portal-footer" role="contentinfo">
      <div className="portal-footer__inner">

        {/* Trust badges */}
        <div className="portal-footer__badges" aria-label="Security trust badges">
          <span className="portal-footer__badge">
            <LockIcon />
            256-bit SSL
          </span>
          <span className="portal-footer__badge">
            <ShieldIcon />
            Secure Payment
          </span>
          <span className="portal-footer__badge portal-footer__badge--upi" aria-label="UPI Enabled">
            <UpiLogo />
            Enabled
          </span>
        </div>

        {/* Copyright */}
        <p className="portal-footer__copy">
          &copy; {year} <a href="https://getnet.live" className="portal-footer__link" target="_blank" rel="noopener noreferrer">GetNet Broadband</a>
          {' '}&mdash; Kopar Khairane, Navi Mumbai
        </p>

        <p className="portal-footer__disclaimer">
          This payment portal is operated directly by GetNet Broadband.
          All payments are processed via UPI through your preferred app.
        </p>

      </div>
    </footer>
  )
}

export default Footer
